import { TApiResponse } from '@/common/types/response';

import { TStatisticsPublicStoreState } from './types';

export function setPagesTable(
  state: TStatisticsPublicStoreState,
  res: TApiResponse<TStatisticsPublicStoreState['pagesTable']>,
) {
  state.pagesTable = res.data;
}

export function setSectionsTable(
  state: TStatisticsPublicStoreState,
  res: TApiResponse<TStatisticsPublicStoreState['sectionsTable']>,
) {
  state.sectionsTable = res.data;
}

export function setViewsCountByTimeTable(
  state: TStatisticsPublicStoreState,
  res: TApiResponse<TStatisticsPublicStoreState['viewsCountByTimeTable']>,
) {
  state.viewsCountByTimeTable = res.data;
}

export function setVisitsCountByTimeTable(
  state: TStatisticsPublicStoreState,
  res: TApiResponse<TStatisticsPublicStoreState['visitsCountByTimeTable']>,
) {
  state.visitsCountByTimeTable = res.data;
}

export function setVisitsCountByTimeChartData(
  state: TStatisticsPublicStoreState,
  res: TApiResponse<TStatisticsPublicStoreState['visitsCountByTimeChartData']>,
) {
  state.visitsCountByTimeChartData = res.data;
}

export function setViewsCountByTimeChartData(
  state: TStatisticsPublicStoreState,
  res: TApiResponse<TStatisticsPublicStoreState['viewsCountByTimeChartData']>,
) {
  state.viewsCountByTimeChartData = res.data;
}
